import { useParams } from "react-router-dom";
import useFetch from "../../commons/hooks/useFetch";
import CreateUpdateStoreForm from "../../components/Form/CreateUpdateStoreForm/CreateUpdateStoreForm";
import { STORE_ADDRESS_URL, STORE_DETAIL_URL } from "../../commons/constants/api-urls";
import { Loading } from "../../commons/components/Loading";
import NotFoundPage from "../NotFound";
import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../contexts/AppContext";
import CloneStoreForm from "../../components/Form/CloneStoreForm/CloneStoreForm";

const CreateUpdateStorePage: React.FC = () => {
  const { findAndSetStore } = useContext(AppContext);
  const { storeId } = useParams<{ storeId: string }>();
  const [openClone, setOpenClone] = useState(false);
  useEffect(() => {
    if (!storeId) return;
    findAndSetStore(storeId);
  }, [storeId]);

  const { data, loading } = useFetch<Store>(storeId ? STORE_DETAIL_URL(storeId) : "");
  const { data: addresses, loading: loadingAddress } = useFetch<StoreAddress[]>(
    storeId ? STORE_ADDRESS_URL(storeId) : ""
  );

  if (loading || loadingAddress) return <Loading />;

  if (storeId && data?.id.toString() !== storeId) return <NotFoundPage />;

  return (
    <>
      <CreateUpdateStoreForm store={data} address={addresses?.[0]} setOpenClone={setOpenClone} />
      <CloneStoreForm store={data} address={addresses?.[0]} open={openClone} setOpenClone={setOpenClone} />
    </>
  );
};

export default CreateUpdateStorePage;
